module.exports = __webpack_public_path__ + "img/1f9ca.d88c6bc.svg";